export enum RevenueActionTypes {
  API_RESPONSE_SUCCESS = "@@revenue/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@revenue/API_RESPONSE_ERROR",

  GET_REVENUE = "@@revenue/GET_REVENUE",
}
